import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useGetActorDetailsQuery, useGetMoviesByActorIdQuery } from '../../services.js/TMDB';
import useStyles from './styles';
import MovieList from '../MovieList/MovieList';
import Pagination from '../Pagination/Pagination';

const Actors = () => {
  const { id } = useParams();
  const { data, isFetching, error } = useGetActorDetailsQuery(id);
  const [page, setPage] = useState(1);
  const { data: actorMovies } = useGetMoviesByActorIdQuery({ id, page });
  const history = useNavigate();
  const classes = useStyles();
  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size="8rem" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" mt="20px">
        <Button startIcon={<ArrowBack />} onClick={() => history.goBack()}>Go back</Button>

      </Box>
    );
  }
  return (
    <>
      <Grid container spacing={3}>
        <Grid item lg={5} xl={4}>
          <img className={classes.image} src={`https://image.tmdb.org/t/p/w780/${data?.profile_path}`} alt={data.name} />
        </Grid>
        <Grid item xl={8} lg={7} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <Typography variant="h2" gutterBottom> {data?.name}</Typography>
          <Typography variant="h5" gutterBottom> Born : {new Date(data?.birthday).toDateString()}</Typography>
          <Typography variant="body1" align="justify" gutterBottom paragraph> {data?.biography || 'Sorry, No biography yet'}</Typography>
          <Box marginTop="2rem" display="flex" justifyContent="space-around">
            <Button variant="contained" color="primary" target="_blank" href={`https://www.imdb.com/name/${data?.imdb_id}`}>IMDB</Button>
            <Button startIcon={<ArrowBack />} onClick={() => history(-1)} color="primary">Go Back </Button>
          </Box>
        </Grid>
      </Grid>
      <Box margin="2rem 0 ">
        <Typography variant="h2" gutterBottom align="center">Movies</Typography>
        {actorMovies && <MovieList movies={actorMovies} />}
        <Pagination currentPage={page} setPage={setPage} totalPages={actorMovies?.total_pages} />
      </Box>
    </>
  );
};

export default Actors;
